import { render } from "./form-status.vue?vue&type=template&id=33b48dae"
import script from "./form-status.vue?vue&type=script&lang=js"
export * from "./form-status.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__